// Config
import { API_MODE } from 'config/api';

export const name = 'request';

export const apiTestUrl = 'http://localhost:3000/api/dev';
export const apiDevUrl = 'https://dev.pro.bhub.com.ua/api/dev';
export const apiProdUrl = 'https://pro.bhub.com.ua/api/dev';

export const apiUrlByEnv =
  API_MODE === 'test' ? apiTestUrl : API_MODE === 'dev' ? apiDevUrl : apiProdUrl;

export const config = {
  name,
  apiTestUrl,
  apiDevUrl,
  apiProdUrl,
  apiUrlByEnv,
};

export default config;
